<template>
  <div class="custom-card flex flex-col gap-4">
    <div>
      <div class="">
        <h2 class="text-lg font-semibold mb-4">Account Security</h2>
        <div class="flex flex-col">
          <h3 class="font-bold text-lg mb-1">Password</h3>
          <div class="flex justify-between">
            <p>
              The same password strength are enforced for all users across the app.
              <a href="" @click.prevent="showPolicyModal = true"> VIEW POLICY </a>
            </p>
            <a href="" class="rounded p-2 font-thin w-48 text-center" style="border: 1px solid blue"
              @click.prevent="showPasswordModal = true">Update Password</a>
          </div>
        </div>
        <div class="flex flex-col my-4">
          <h3 class="font-bold text-lg mb-1">Two Factor Authentication</h3>
          <div class="flex justify-between">
            <p class="flex">
              Two factor authentication enforced for all users within your domain.
              <el-tooltip class="item" effect="dark" placement="top-start">
                <div slot="content">Admin can enable 2FA for the <br /> rest of the users in any account. <br />When
                  enabled
                  users
                  MUST set-up <br /> their 2FA in their next login.</div>

                <span>
                  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M11.5 7H9.5V5H11.5V7ZM11.5 15H9.5V9H11.5V15ZM10.5 0C9.18678 0 7.88642 0.258658 6.67317 0.761205C5.45991 1.26375 4.35752 2.00035 3.42893 2.92893C1.55357 4.8043 0.5 7.34784 0.5 10C0.5 12.6522 1.55357 15.1957 3.42893 17.0711C4.35752 17.9997 5.45991 18.7362 6.67317 19.2388C7.88642 19.7413 9.18678 20 10.5 20C13.1522 20 15.6957 18.9464 17.5711 17.0711C19.4464 15.1957 20.5 12.6522 20.5 10C20.5 8.68678 20.2413 7.38642 19.7388 6.17317C19.2362 4.95991 18.4997 3.85752 17.5711 2.92893C16.6425 2.00035 15.5401 1.26375 14.3268 0.761205C13.1136 0.258658 11.8132 0 10.5 0Z"
                      fill="#383F51" />
                  </svg>
                </span>
              </el-tooltip>
            </p>
            <a href="" class="rounded p-2 font-thin w-48 text-center" style="border: 1px solid blue"
              @click.prevent="showTwoFactorModal = true">Configure</a>
          </div>
        </div>
      </div>
      <update-password-modal :show-modal="showPasswordModal" @close-modal="showPasswordModal = false" />
      <password-policy-modal :show-modal="showPolicyModal" @close-modal="showPolicyModal = false" />
      <security-question-modal :show-modal="showSecurityQuestionModal"
        @close-modal="showSecurityQuestionModal = false" />
      <two-factor-modal :show-modal="showTwoFactorModal" @close-modal="showTwoFactorModal = false" />
    </div>
  </div>
</template>

<script>
import UpdatePasswordModal from "@/views/3pl/Settings/SecurityPolicy/Modals/UpdatePassordModal";
import SecurityQuestionModal from "@/views/3pl/Settings/SecurityPolicy/Modals/SecurityQuestionModal";
import TwoFactorModal from "@/views/3pl/Settings/SecurityPolicy/Modals/TwoFactorModal";
import PasswordPolicyModal from "@/views/3pl/Settings/SecurityPolicy/Modals/PasswordPolicyModal";
export default {
  components: {
    UpdatePasswordModal,
    SecurityQuestionModal,
    TwoFactorModal,
    PasswordPolicyModal
  },
  data() {
    return {
      showSecurityQuestionModal: false,
      showPasswordModal: false,
      showTwoFactorModal: false,
      showPolicyModal: false,
      newUser: {
        fname: "",
        mname: "",
        lname: "",
        gender: "",
        email: "",
        phoneNo: "",
        employmentType: "",
        // imageurl: "",
      },
      user: {
        // id: "7dea03b7-c2d6-4540-89b9-40119db6d81f",
        firstname: "oba",
        middlename: "three",
        lastname: "pl",
        gender: "male",
        email: "thevetdoctor@gmail.com",
        hash:
          "5fd56c1fee8f10c161f9f14b536895062008f50b6b4d0ad45164cb80aca7ae8bc37e375d9c7ed1dd5deb8b6e400ed790b44fd6432089386e97730e3fce4d910d",
        salt: "6e930199a117a78a1090c8ac1510c110e9972e4c3e24f45568472f4309201c42",
        accounttype: "organization",
        image: null,
        imageurl:
          "https://cloudenly-primary.s3.eu-west-2.amazonaws.com/muleex/1630526780862-1626247746317.jpg",
        onboardingtype: "3PL",
        mobile_no: "08069100466",
        twoFA: null,
        securityques: null,
        answer: null,
        createdAt: "2021-08-24T19:31:07.409Z",
        updatedAt: "2021-10-13T10:15:59.754Z",
        passwordauth: null,
        Orgs: [
          {
            id: "a62faded-e513-41b9-b2f7-5f1c21d49bf8",
            userId: "7dea03b7-c2d6-4540-89b9-40119db6d81f",
            companyname: "updated organization name",
            customdomain: "obang",
            industry: "Agriculture",
            regnumber: "oba01",
            mobile_no: "0806 910 0463",
            email: "thevetdoctor@gmail.com",
            image: null,
            imageurl: "",
            specialization: "Agro-Allied Services",
            address: "updated organization address",
            city: null,
            country: null,
            type: null,
            stateId: null,
            twoFA: null,
            web: null,
            facebook: null,
            linkedin: null,
            twitter: null,
            instagram: null,
            createdAt: "2021-08-24T19:33:22.072Z",
            updatedAt: "2021-10-06T23:58:12.243Z",
          },
        ],
      },
      genders: ["Male", "Female"],
      languages: ["English"],
      employmentTypes: [
        "Full-time",
        "Part-time",
        "Intern",
        "Company-paid Temporary",
        "Independent Contractor",
        "Agency-paid Temporary",
        "Vendor Employee",
        "Volunteer",
      ],
      creatingUser: false,
      roles: [],
      selectedRoleId: "",
      isUploadingImage: false,
      updatingUser: false,
    };
  },
  computed: {
    disableButton() {
      return this.shouldDisableButton(this.newUser);
    },
    // user() {
    //   return JSON.parse(localStorage.getItem("loggedInUser"));
    // },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("loggedInUser"));
    console.log(this.user);
    if (!this.user) {
      this.$router.push("/login");
    }
  },
  methods: {
    async updateUser() {
      this.updatingUser = true;
      this.deleteExcessData();
      // endpoint expects userId not id
      this.user.userId = this.user.id;
      try {
        let response = await this.$_saveAccountOwnerInformation(this.user);
        console.log(response);
        this.$store.dispatch("saveUserDetails", response.data.updateUser);
        this.generateToast("Your information has been updated!", "success");
        this.updatingUser = false;
        this.$router.push({ name: "AccountProfile" });
      } catch (error) {
        this.handleError(error);
        this.updatingUser = false;
      }
    },
    deleteExcessData() {
      // removes the unneeded properties from the user object
      delete this.user.Orgs;
      delete this.user.createdAt;
      delete this.user.passwordauth;
      delete this.user.updatedAt;
      delete this.user.twoFA;
      delete this.user.securityques;
      delete this.user.onboardingtype;
      delete this.user.salt;
      delete this.user.hash;
      delete this.user.accounttype;
      delete this.user.answer;
      console.log(this.user);
    },
    async uploadImage(image) {
      // console.log(image);
      this.isUploadingImage = true;
      const formData = new FormData();
      formData.append("file", image);
      formData.append("upload_preset", "zunt8yrw");
      try {
        let response = await this.$_uploadImage(formData);
        // console.log(response);
        this.user.imageurl = response.data.secure_url;
        this.generateToast("Image uploaded", "success");
        this.isUploadingImage = false;
      } catch (error) {
        this.handleError(error);
        this.isUploadingImage = false;
      }
    },
    removeImage() {
      this.user.imageurl = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.picture-upload-form {
  /* border: 1px solid #edf2ef; */
  border-radius: 10px;
  padding: 1.55rem 1rem;
}

.picture-upload-form__img-wrapper {
  position: relative;
}

.user-img {
  width: 10rem;
  margin: 1.5rem auto;
}

.upload-img-icon {
  position: absolute;
  right: 3.5rem;
  bottom: 1rem;
}

.picture-upload-form__meta {
  padding-top: 1rem;
}

.label {
  font-size: 0.9rem;
}

.input {
  margin-bottom: 0.5rem;
}

.new-user-form__col-three {
  padding-top: 1.25rem;
}

hr {
  margin: 2rem 0;
}

.input-row {
  width: 100%;
  display: flex;
}

.input-row>div {
  width: 100%;
  padding-right: 1rem;
}

.modal-input {
  background: #fafafd;
  border: 0.5px solid #c5d1e6;
  height: 2.75rem;
  border-radius: 4px;
  display: flex;

  input {
    border: none;
    background: transparent;
  }

  span {
    align-self: center;
    padding-right: 0.5rem;
    color: #747474;
    cursor: pointer;
  }
}

@media screen and (max-width: 768px) {
  .input-row {
    flex-direction: column;
  }

  .input-row div {
    width: 100%;
  }
}
</style>
